<template lang="html">

  <section class="car_model">   
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <b-collapse id="car_model_filters" class="mt-2 ml-4 mr-4">
            <b-card>
              <p class="card-text">Filters</p>
              <div class="row">
                <div class="col-lg-3">Modelcode:</div><input type="text" class="col-lg-3" v-model="modelcodeFilter" placeholder="Modelcode"/>
                <div class="col-lg-3">My range:</div><input type="text" class="col-lg-3" v-model="rangeMYFilter" placeholder="My range"/>
              </div>
              <div class="row mt-2">
                <div class="col-lg-3">Description:</div><input type="text" class="col-lg-3" v-model="descriptionFilter" placeholder="Description"/>
                <div class="col-lg-3">Active:</div>
                <b-form-select class="col-lg-3" v-model="activeFilter">
                  <b-form-select-option :value="null">---</b-form-select-option>
                  <b-form-select-option :value="true">Yes</b-form-select-option>
                  <b-form-select-option :value="false">No</b-form-select-option>
                </b-form-select>
              </div>
              <b-button variant="primary" v-b-toggle.car_model_filters @click="search()"><i class="mdi mdi-magnify"></i>Search</b-button>
            </b-card>
          </b-collapse>
          <div class="col-lg-12 card-body row">
            <div class="col-lg-3">
              <h4 class="card-title">Car Models</h4>
              <p class="card-description">
                {{curModel}} - {{getCurModel7DigitsCode}} - {{getLanguageLabel}}
              </p>
            </div>
            <div class="col-lg-4">
             
              <div class="col-lg-12 row">
                <b-pagination
                  align="fill"
                  limit="4"
                  v-model="currentPage"
                  :total-rows="totalRowsResult"
                  :per-page="perPage"
                  first-text="<<"
                  prev-text="<"
                  next-text=">"
                  last-text=">>"
                  ellipsisText="..."
                  aria-controls=""
                  class="col-lg-9"
                ></b-pagination>
                <b-form-select id="perPage-dd" v-model="perPage" class="col-lg-3">
                  <b-form-select-option value="5">5</b-form-select-option>
                  <b-form-select-option value="10">10</b-form-select-option>
                  <b-form-select-option value="20">20</b-form-select-option>
                  <b-form-select-option value="50">50</b-form-select-option>
                  <b-form-select-option value="100">100</b-form-select-option>
                </b-form-select>
              </div>
            </div>
            <div class="col-lg-5">
              <span class="float-right">
                <b-button variant="primary mr-1" @click="refreshTable"><i class="mdi mdi-refresh"></i>Refresh Table</b-button>
                <b-button variant="primary mr-1" v-b-toggle.car_model_filters><i class="mdi mdi-filter"></i></b-button>
                <b-button variant="primary mr-1" v-b-modal.modal-new-model @click="btnNew"><i class="mdi mdi-plus"></i>New</b-button>
                <!--<b-button variant="primary mr-1"><i class="mdi mdi-file-export"></i>Export</b-button>
                <b-button variant="primary"><i class="mdi mdi-file-import"></i>Import</b-button>-->
              </span>
            </div>
            <b-table ref="car_model_tab"
              id="table" 
              striped 
              hover 
              responsive 
              :items="items" 
              :fields="fields"
              :per-page="perPage"
              :current-page="1"
              primary-key="code"
              no-local-sorting
              no-provider-paging
              sort-icon-left
            > 
            <!-- isMandatoryCheckBox Button -->
              <template v-slot:cell(downloadIcon)="data" lang="html">
                <b-row>
                 <h4 class="panel-title" style="margin:auto;">                 
                  <b-button v-if="data.item.modelcode!='DEFAULT'" class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-tooltip.hover title="Download zip Family Icon" @click="curItem=data.item; downloadZip(data.item)">
                    <i  class="mdi mdi-briefcase-download btn-outline-secondary" style="display: block;"></i>
                  </b-button>
                   <b-button  v-else class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-tooltip.hover  disabled>
                    <i  class="mdi mdi-briefcase-download btn-outline-secondary" style="display: block;"></i>
                  </b-button>          
                </h4>
                </b-row>
              </template>
               <template v-slot:cell(info_icon)="data" lang="html">             
                  <b-row>               
                    <b-button v-if="data.item.modelcode!='DEFAULT'" class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-tooltip.hover title="opt info" @click="curItem=data.item; showInfo(curItem)" >
                     <i class="mdi mdi-information-outline"></i>
                    </b-button>
                     <b-button v-else class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-tooltip.hover title="opt info" disabled >
                     <i class="mdi mdi-information-outline"></i>
                    </b-button>                
                  </b-row>
              </template>
            <!-- isMandatoryCheckBox Button -->
              <template v-slot:cell(activeButton)="data" lang="html">
                <b-row>
                 <h4 class="panel-title" style="margin:auto;">                 
                  <b-button v-if="!data.item.ccadmActive" class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-tooltip.hover title="Attiva Modello" @click="curItem=data.item; toggleModelStatus(data.item,true)">
                    <i  class="mdi mdi-close-outline btn-outline-secondary" style="display: block;"></i>
                  </b-button>
                  <b-button v-else class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary"  v-b-tooltip.hover title="Disattiva Modello" @click="curItem=data.item; toggleModelStatus(data.item,false)">
                    <i class="mdi mdi-check-outline btn-outline-success" style="display: block;"></i>
                  </b-button>
                 </h4>
                 <b-button class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-modal.modal-edit @click="curItem=data.item">
                    <i class="mdi mdi-pencil"></i>
                  </b-button>
                </b-row>
              </template>
              <!-- ActiveButton -->
          
              <!-- A custom formatted column -->
              <!-- A custom formatted column -->
              <template v-slot:cell(model_management)="data" lang="html">
                <b-row>
                  <b-button class="col-lg-3 p-1 m-auto" style="min-width: 2.875rem;" size="sm" variant="primary" title="Apri gestione modelli" @click='goToCountryModels(data.item.modelcode, data.item.modelcode + " - " + data.item.description)'>
                    <i class="mdi mdi-link-variant"></i>
                  </b-button>
                </b-row>
              </template>


            <b-tooltip target="tooltip-target-1" triggers="hover">                    
            </b-tooltip>
            </b-table>
           
            <b-modal id="modal-edit" title="Edit" v-if="curItem" size="lg" header-bg-variant="primary" header-text-variant="light" centered>
              <b-container fluid>
                <b-row>
                  <div class="col-lg-3">Modelcode*:</div><input type="text" class="col-lg-3" placeholder="Modelcode" v-model="curItem.modelcode" disabled/>
                  <div class="col-lg-3">Description*:</div><input type="text" class="col-lg-3" placeholder="Description" v-model="curItem.description"/>
                </b-row>
                <hr>
                <b-row>
                  <div class="col-lg-3">MY key active*:</div><input type="text" class="col-lg-3" placeholder="MY key active" v-model="curItem.myKeyActive"/>
                  <div class="col-lg-3">Max my video available:</div><input type="text" class="col-lg-3" placeholder="Max my video available" v-model="curItem.maxMyVideoAvailable"/>
                </b-row>
                <hr>
                <b-row>
                  <div class="col-lg-3">Show watermark:</div>
                  <b-form-select class="col-lg-3" v-model="curItem.showWatermark">
                    <b-form-select-option :value="true">Yes</b-form-select-option>
                    <b-form-select-option :value="false">No</b-form-select-option>
                  </b-form-select>
                </b-row>
              </b-container>
              <template v-slot:modal-footer="{ cancel, ok }" lang="html">
                <fragment>
                  <b-button variant="secondary" @click="cancel()">
                    Annulla
                  </b-button>
                  <b-button variant="primary" @click="saveCurItem(curItem)">
                    Salva
                  </b-button>
                </fragment>
              </template>
            </b-modal>

            <b-modal id="modal-new-model" title="New Car Model" size="lg" header-bg-variant="primary" header-text-variant="light" centered>
              <b-container fluid>
                <b-row>
                  <div class="col-lg-3">Modelcode*:</div><input type="text" class="col-lg-3" placeholder="Modelcode" v-model="newItem.modelcode" />
                  <div class="col-lg-3">Description*:</div><input type="text" class="col-lg-3" placeholder="Description" v-model="newItem.description"/>
                </b-row>
                <hr>
                <b-row>
                  <div class="col-lg-3">MY key active*:</div><input type="text" class="col-lg-3" placeholder="MY key active" v-model="newItem.myKeyActive"/>
                  <div class="col-lg-3">Max my video available:</div><input type="text" class="col-lg-3" placeholder="Max my video available" v-model="newItem.maxMyVideoAvailable"/>
                </b-row>
                <hr>
                <b-row>
                  <div class="col-lg-3">Show watermark:</div>
                  <b-form-select class="col-lg-3" v-model="newItem.showWatermark">
                    <b-form-select-option :value="true">Yes</b-form-select-option>
                    <b-form-select-option :value="false">No</b-form-select-option>
                  </b-form-select>
                </b-row>
              </b-container>
              <template v-slot:modal-footer="{ cancel, ok }" lang="html">
                <fragment>
                  <b-button variant="secondary" @click="cancel()">
                    Annulla
                  </b-button>
                  <b-button variant="primary" @click="createItem(curItem)">
                    Salva
                  </b-button>
                </fragment>
              </template>
            </b-modal>
            
          </div>
        </div>
      </div>
    </div>
  </section>

</template>
<style>
.expandableContent {
  transition: 300ms ease-out;
}
.closed {
  height: 0vh !important;
}
.table td,
.table th {
  max-width: 25vw;
}

li.nav-item.active > a {
  color: #fff !important;
  text-shadow: 2px 2px 4px rgba(100, 100, 100, 0.5);
}
</style>
<script lang="js">
import { mapState, mapActions, mapGetters } from "vuex";
 const FileDownload = require('js-file-download');
export default {
  name: 'car_model',
  methods: {
    showInfo(curItem){
      this.setSpinnerStatus(true);
       console.log(curItem.modelcode)
       this.axios
        .get('/ccb/auth/api/getCountryListByModel/'+curItem.modelcode ,  {
        ...this.authHeader}          
          ).then((response) => {
            window.datas = response.data;        
            const messageNodes = this.$createElement(
                'pre',
                {
                  domProps: { innerHTML: response.data }
                }
              )


            this.$bvModal.msgBoxOk([messageNodes], {
                okVariant: 'success',
                hideHeaderClose: false,
                centered: true
              }).then(value=>{
               
                
              })
              setTimeout(() => {
                  document.querySelector('.modal-dialog-centered').classList.add('scaled')  
                }, 10);                 
          }).finally(resp=>{
            this.setSpinnerStatus(false);
          });
    },
    expandItem(element){
      console.log(element)
      this.accordionManager()
    },
  accordionManager () {
    document.querySelectorAll('tr[role=row][data-pk]').forEach(el=>{     
      var tr = document.createElement('tr')
          tr.className = 'expandableContent closed';
      var td = document.createElement('td')
          td.setAttribute('colspan',6);
          td.style.backgroundColor = 'yellow';  

          tr.appendChild(td);
          el.parentNode.appendChild(tr);
          el.parentNode.insertBefore(el,tr)
    })
  },
    toggleModelStatus(item,visibilityValue) {
      item.ccadmActive=visibilityValue;
      this.saveCurItem(item);         
    },
    saveCurItem(curItem) {
      window.curr = curItem
      this.setSpinnerStatus(true);
      var intLabObj =  curItem;  
      this.axios
      .put('/ccb/auth/fe/commercialModel/' + curItem.modelcode, intLabObj ,this.authHeader)
      .then(response => {
        if(response.status == 200) {            
            this.$bvModal.msgBoxOk(response.data.message, {
              okVariant: 'success',
              hideHeaderClose: false,
              centered: true
            })
            .then(value => {
            this.refreshTable();
            })
          }
        }
      )
      .catch(error => {
            this.$bvModal.msgBoxOk(error.message, {
              okVariant: 'danger',
              hideHeaderClose: false,
              centered: true
            })
          })
          .finally(e=>{
          this.setSpinnerStatus(false);
          this.$bvModal.hide('modal-edit')
        })
    },
    downloadZip (curItem) {
      this.setSpinnerStatus(true); 
      window.curr = curItem
      var intLabObj =  curItem;
      this.axios
          .get('auth/api/downloadFamilyIconZipStructure?modelName=' + curItem.modelcode, {
            responseType: 'blob',params: null ,...this.authHeader})
          .then(response => {
            var disposition = response.headers['content-disposition'];
            var filenameRegex = /fileName[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            var filename = matches[1].replace(/['"]/g, '');
            FileDownload(response.data, filename);
        });
      this.setSpinnerStatus(false);
    },
    createItem() {
    var intLabObj = this.newItem     
    if((intLabObj.modelcode==null || intLabObj.description==null) || (intLabObj.modelcode.trim()=="" || intLabObj.description.trim()=="")) {
      this.$bvModal.msgBoxOk("Inserisci tutti i campi obbligatori", {
        okVariant: 'danger',
        hideHeaderClose: false,
        centered: true
      })
    }else{
      this.setSpinnerStatus(true);       
      this.axios
        .post('/ccb/auth/fe/commercialModel', intLabObj, this.authHeader)
        .then(response => {
          if(response.status == 200) {
            this.$bvModal.msgBoxOk(response.data.message, {
              okVariant: 'success',
              hideHeaderClose: false,
              centered: true
            })
            .then(value => {
              this.refreshTable();
            })
          }  
        })
        .catch(error => {
          this.$bvModal.msgBoxOk(error.message, {
            okVariant: 'danger',
            hideHeaderClose: false,
            centered: true
          })
        }).finally(e=>{
          this.setSpinnerStatus(false);
          this.$bvModal.hide('modal-new-model');
        })
      }
    },
    search() {
      this.setLastSearch(this.search)
      this.setSpinnerStatus(true)

      var params = {
        page: this.currentPage - 1,
        size: this.perPage,
        sortBy: this.sortBy,
        sortDesc: this.sortDesc
      }

      var filter = {
        modelcode: this.modelcodeFilter ? this.modelcodeFilter : null,
        myrange: this.rangeMYFilter ? this.rangeMYFilter : null,
        description: this.descriptionFilter ? this.descriptionFilter : null,
        ccadmActive: this.activeFilter
      }

      this.axios
        .post('/ccb/auth/fe/commercialModel/allPaged', filter, {
          params: params,
          ...this.authHeader
        })
        .then((response) => {
          this.setSpinnerStatus(false);
          window.datas = response.data;
          this.setCarModelList(response.data.content);
          this.totalRowsResult = response.data.totalElements;
        })
        .catch(() => {
          this.setSpinnerStatus(false);
        });
    },
    goToCountryModels(idKey,title){
          this.$router.push({name: "country_models", params: { idKey : idKey, from: 'car_model',title: title }}); 
    },        
    btnNew() {
        setTimeout(() => {
        var atG = this.getCurLabelGroup
      }, 500);
    },
    refreshTable() {
        this.search();
    },
    ...mapActions([
      'setCurApp',
      'setLastSearch',
      'setCarModelList',
      'setSpinnerStatus'
      
    ]),
    loadLanguages () {
       this.axios
      .get('/ccb/auth/fe/commercialModel/langlist' ,  {
        params:null,
        ...this.authHeader}
          
          )
          .then((response) => {
            localStorage.setItem('langList', JSON.stringify( response.data));
            this.setLanguageList(response.data);          
          });
    },
  },
  props: ['action','activeGroup'],
  data () {
    return {
      totalRowsResult: 0,
      allLanguages: [],
      routerParams: null,
      currentPage:1,
      perPage:10,
      sortBy:'modelcode',
      sortDesc: false,
      curItem:null,
      newItem : {id:null, commercialModel: null,  labelGroup: null, code : null ,label: null ,modelEnableRegexp: 'DEFAULT' , modelDisableRegexp: null, showWatermark: false, myKeyActive: null},
      fields: [
        {
          key: 'modelcode',
          label: 'Modelcode',
          sortable: false
        },
        {
          key: 'myrange',
          label: 'My range',
          sortable: false
        },        
        {
          key: 'downloadIcon',
          label: 'Download All Icons of Family',
          sortable: false
        },
        {
          key: 'info_icon',
          label: 'Info',
          sortable: false
        },
        {
          key: 'description',
          label: 'Description',
          sortable: false
        },
        {
          key: 'model_management',
          label: 'Model Management',
          sortable: false,
          visible : true
        },                
         {
          key: 'activeButton',
          label: 'Active',
          sortable: false
        }
      ],
      modelcodeFilter: '',
      rangeMYFilter: '',
      descriptionFilter: '',
      activeFilter: null
    }
  },
  computed: {
    getAllLanguages(){
      return this.allLanguages;
    },
    items () {
      return (this.getCarModelList && this.getCarModelList.length) ? this.getCarModelList : [];
    },
    ...mapState([
      'curLanguage',
      'curModel',
       'models'
    ]),
    ...mapGetters([
      'getCurModel7DigitsCode',
      'getLanguageLabel',
      'authHeader',
      'getCurLabelGroup',
      'getCurLanguage',
      'getCurLanguageObj',
      'getCurModel',
      'getCarModelList'
    ])
  },
   watch: {
     $route (to,from){
       this.routerParams = to;
       if(to.query.activeGroup && to.query.activeGroup !=null){
          this.setCurLabelGroup(to.query.activeGroup);        
        }
       if(to.query.action && to.query.action === 'search'){
        // alert('search')
        this.search();        
       }
     },
    items (oldValue, newValue) {
      console.log(this.$refs)
      this.$refs.car_model_tab.refresh();
    },
     currentPage(newValue,oldValue){
      this.refreshTable();
    },
    perPage(newValue,oldValue){
      this.refreshTable();
    },
    sortBy(newValue,oldValue){
      this.refreshTable();
    },
    sortDesc(newValue,oldValue){
      this.refreshTable();
    }
  },
  mounted() {
    window.scoper = this
    this.search();     
    this.setCurApp('ccadm');
  }
}
</script>

<style scoped lang="scss">
@import "../../../assets/scss/_variables.scss";
.collapse {
  border: 1px solid $gray-lightest;
  border-radius: 0.25rem;
}
</style>
